import React, { useState } from 'react'
import toast from 'react-hot-toast'
import { lumi } from '@/lib/lumi'
import {Lock, Mail, Loader2} from 'lucide-react'

const AdminLogin: React.FC = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!email || !password) {
      toast.error('Veuillez renseigner votre email et votre mot de passe.')
      return
    }
    setSubmitting(true)
    try {
      await lumi.auth.signInWithPassword({ email, password })
      toast.success('Connexion réussie.')
    } catch (error) {
      console.error('Échec de la connexion:', error)
      toast.error('Identifiants incorrects. Veuillez réessayer.')
    } finally {
      setSubmitting(false)
    }
  }

  const handleOAuth = async () => {
    try {
      await lumi.auth.signInWithOAuth({ provider: 'google' })
    } catch (error) {
      console.error('Échec de la connexion OAuth:', error)
      toast.error('La connexion a échoué.')
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0E1B2C] px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <p className="text-[#C9A86A] tracking-[0.3em] text-xs uppercase mb-4">Espace réservé</p>
          <h1 className="font-serif text-4xl text-[#E8DCC4]">Administration</h1>
          <p className="text-[#E8DCC4]/50 text-sm mt-3">
            Connectez-vous pour gérer le contenu du site.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="relative">
            <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[#C9A86A]" />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              className="w-full pl-11 pr-4 py-3.5 bg-[#14253B] border border-[#E8DCC4]/15 rounded-xl text-[#E8DCC4] placeholder:text-[#E8DCC4]/30 focus:outline-none focus:border-[#A3C644] transition-colors"
            />
          </div>
          <div className="relative">
            <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[#C9A86A]" />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Mot de passe"
              className="w-full pl-11 pr-4 py-3.5 bg-[#14253B] border border-[#E8DCC4]/15 rounded-xl text-[#E8DCC4] placeholder:text-[#E8DCC4]/30 focus:outline-none focus:border-[#A3C644] transition-colors"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            className="w-full py-3.5 bg-[#A3C644] text-[#0E1B2C] font-semibold rounded-xl hover:bg-[#b4d655] transition-colors disabled:opacity-60 flex items-center justify-center gap-2"
          >
            {submitting && <Loader2 className="w-4 h-4 animate-spin" />}
            Se connecter
          </button>
        </form>

        <div className="flex items-center gap-4 my-6">
          <div className="flex-1 h-px bg-[#E8DCC4]/10" />
          <span className="text-[#E8DCC4]/30 text-xs">ou</span>
          <div className="flex-1 h-px bg-[#E8DCC4]/10" />
        </div>

        <button
          onClick={handleOAuth}
          className="w-full py-3.5 border border-[#E8DCC4]/15 text-[#E8DCC4] rounded-xl hover:border-[#C9A86A] transition-colors"
        >
          Continuer avec Google
        </button>

        <p className="text-center text-[#E8DCC4]/40 text-xs mt-8">
          <a href="/" className="hover:text-[#A3C644] transition-colors">← Retour au site</a>
        </p>
      </div>
    </div>
  )
}

export default AdminLogin
